import { render, staticRenderFns } from "./ProductServicesList.vue?vue&type=template&id=613f0f5c&scoped=true&"
import script from "./ProductServicesList.vue?vue&type=script&lang=ts&"
export * from "./ProductServicesList.vue?vue&type=script&lang=ts&"
import style0 from "./ProductServicesList.vue?vue&type=style&index=0&id=613f0f5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613f0f5c",
  null
  
)

export default component.exports